import { render, staticRenderFns } from "./Custom1List.vue?vue&type=template&id=171e8b06&scoped=true&"
import script from "./Custom1List.vue?vue&type=script&lang=js&"
export * from "./Custom1List.vue?vue&type=script&lang=js&"
import style0 from "./Custom1List.vue?vue&type=style&index=0&id=171e8b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e8b06",
  null
  
)

export default component.exports